var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nkn-developer"},[_c('div',{staticClass:"containers"},[_c('div',{staticClass:"nkn-container"},[_c('developer-client-intro')],1),_vm._v(" "),_c('div',{staticClass:"nkn-container"},[_c('developer-core-tech')],1),_vm._v(" "),_c('developer-dapp'),_vm._v(" "),_c('div',{staticClass:"nkn-container"},[_c('developer-resources')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c87f0be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DeveloperPortal.vue
// module id = null
// module chunks = 